import {
  aromaTextarea,
  AromaTextareaVariantProps,
} from "@zenchef/styled-system/recipes";
import { ElementRef, forwardRef } from "react";
import { Field, type FieldTextareaProps } from "@ark-ui/react";
import Icon from "../Icon/Icon";
import { cx } from "@zenchef/styled-system/css";
import { FieldProps } from "../../utils/types";

export interface TextareaProps
  extends AromaTextareaVariantProps,
    FieldTextareaProps,
    FieldProps {}

const Textarea = forwardRef<ElementRef<"div">, TextareaProps>(
  ({ className, testId, ...propsWithVariants }, ref) => {
    const [variants, props] =
      aromaTextarea.splitVariantProps(propsWithVariants);
    const classes = aromaTextarea(variants);
    const { required, disabled } = props;

    const testIds = testId
      ? {
          root: testId,
          textarea: `${testId}-textarea`,
        }
      : {};

    return (
      <Field.Root
        ref={ref}
        className={cx(classes.container, className)}
        disabled={disabled}
        data-testid={testIds.root}
      >
        <Field.Textarea
          className={classes.textarea}
          data-testid={testIds.textarea}
          {...props}
        />
        {required ? <Icon name="asterisk" aria-required="true" /> : null}
      </Field.Root>
    );
  },
);

export default Textarea;
